import { useState, useEffect } from 'react';

const BREAKPOINTS = {
  LARGE: 1480, // ≥1480px
  MEDIUM: 1380, // 1380–1479px
  // ≤1379px = small
};

const getViewport = () => {
  // guard for SSR / non-browser
  const width = typeof window !== 'undefined' ? window.innerWidth : BREAKPOINTS.LARGE;

  const isLarge = width >= BREAKPOINTS.LARGE; // ≥1480
  const isMedium = width >= BREAKPOINTS.MEDIUM && width < BREAKPOINTS.LARGE; // 1380–1479
  const isSmall = width < BREAKPOINTS.MEDIUM; // ≤1379

  return {
    width,
    isLarge,
    isMedium,
    isSmall,
    // convenience flag: title truncation kicks in on small screens
    shouldTruncateTitle: isSmall,
  };
};

const useViewportSize = () => {
  const [viewport, setViewport] = useState(getViewport);

  useEffect(() => {
    let frame = null;

    const handleResize = () => {
      // throttle with rAF to avoid excessive re-renders during drag-resize
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        setViewport(getViewport());
      });
    };

    window.addEventListener('resize', handleResize);
    // sync once on mount in case size changed before listener attached
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return viewport;
};

export default useViewportSize;
